import { render, staticRenderFns } from "./FieldPhone.vue?vue&type=template&id=3e4e8d27&"
import script from "./FieldPhone.vue?vue&type=script&lang=js&"
export * from "./FieldPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports